import NotificationContainer from '@common/components/NotificationContainer';
import userPersonas from '@common/constants/userPersonas';
import { Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

interface Props {
  createManualPaymentOnClick: () => any;
  closeManualPaymentModal: () => any;
}

const ManualPaymentModal = ({ closeManualPaymentModal, createManualPaymentOnClick }: Props) => {
  return (
    <Modal
      open={true}
      trigger={null}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeManualPaymentModal();
        }
      }}
      header={<Heading level={2}>Mark this month as paid?</Heading>}
      body={
        <>
          <NotificationContainer modal persona={userPersonas.RENTER} />
          <Paragraph>When you mark a month as paid, it cannot be undone.</Paragraph>
        </>
      }
      footer={
        <ButtonGroup aria-label="Mark payment as paid">
          <TextButton onClick={closeManualPaymentModal}>Back</TextButton>
          <Button emphasis="filled" onClick={createManualPaymentOnClick}>
            Mark as paid
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default ManualPaymentModal;
